import {forwardRef} from 'react';
import {CarouselElement} from '../../../carousel/CarouselElement.interface';
import {twMerge} from '../../../common/twMerge';
import {Indicator} from '../../atoms/Indicator/Indicator';
import {CarouselProps} from './CarouselProps.interface';
import {getCalculatedCarouselTranslateX} from './getCalculatedCarouselTranslateX.function';
import {useCarouselValues} from './useCarouselValues';

export const Carousel = forwardRef<CarouselElement | null, CarouselProps>(
  ({responsive, children, className, ...carouselProps}, ref) => {
    const {
      carouselRef,
      carouselWrapperRef,
      responsiveCarouselProps,
      validChildren,
      cloneElementCount,
      carouselItemCount,
      currentIndex,
      _centerPadding,
      isLeftSideMode,
      onTouchEndCarousel,
      onTouchMoveCarousel,
      onTouchStartCarousel,
      onMouseDownCarousel,
      onClickNextArrow,
      onClickPrevArrow,
      renderCloneItems,
      renderItems,
      renderNextArrow,
      renderPrevArrow,
      renderDots,
    } = useCarouselValues({
      responsive,
      children,
      className,
      ref,
      ...carouselProps,
    });

    return (
      <div
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={twMerge(
          'carousel-container',
          'relative h-full touch-pan-y',
          className
        )}
        {...responsiveCarouselProps}
        ref={carouselWrapperRef}
      >
        {carouselItemCount === 1 && (
          <div className="flex justify-center">
            <div style={{width: `calc(100% - calc(${_centerPadding} * 2))`}}>
              {validChildren[0]}
            </div>
          </div>
        )}
        {carouselItemCount >= 2 && (
          <div
            ref={carouselRef}
            className="flex"
            style={
              isLeftSideMode
                ? {
                    // 초기값만 잡아주고, 이 후로는 animation에 의해 동작함
                    transform: 'translateX(9px)',
                  }
                : {
                    // 초기값만 잡아주고, 이 후로는 animation에 의해 동작함
                    transform: `translateX(${getCalculatedCarouselTranslateX(
                      cloneElementCount,
                      _centerPadding
                    )})`,
                  }
            }
            onTouchStart={onTouchStartCarousel}
            onTouchMove={onTouchMoveCarousel}
            onTouchEnd={onTouchEndCarousel}
            onMouseDown={onMouseDownCarousel}
          >
            {renderCloneItems('prev')}
            {renderItems()}
            {renderCloneItems('next')}
          </div>
        )}
        {renderNextArrow?.(onClickNextArrow)}
        {renderPrevArrow?.(onClickPrevArrow)}
        {renderDots?.(currentIndex, carouselItemCount)}
        {isLeftSideMode && (
          <Indicator
            currentIndex={currentIndex}
            numberOfItem={carouselItemCount}
            className="py-24pxr"
          />
        )}
        <style jsx>
          {`
            .carousel-container :global(*) {
              max-height: 100%;
            }
          `}
        </style>
      </div>
    );
  }
);
